import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import ErrorMessages, {MessageItem} from '@as_core/elements/UserMessages';
import {UserEmailDictionaryT} from '../hooks/useUserEmails';
import {
  DashboardCategoriesT,
  DashboardCategories,
  organizeRequestsForDashboard,
  RequestT,
  canPartnerUpdateCategory
} from '../hooks/useRequests';
import CategoryContainer from "@subApps/requests/common/CategoryContainer";
import RequestStageTiles from "@subApps/requests/partners/RequestStageTiles";


interface PropsI {
  requestType?: string;
  requests: RequestT[];
  handleClick: (t: string, id: number) => void;
  userEmails: UserEmailDictionaryT;
}

const debug = false;
const RequestsTiles = (props: PropsI) => {
  const { requestType = 'Screen', requests, handleClick, userEmails } = props;
  const [requestsByCategories, setRequestsByCategories] = useState<DashboardCategoriesT>(
    organizeRequestsForDashboard(requests)
  );
  debug && console.log(
    `partners/RequestsTable | requestType: ${requestType}, requests:`, requests,
    'requestsByCategories', requestsByCategories
  );

  function getRequestCountsLabel (numberRequests: number) {
    if (numberRequests > 1) return ` (${numberRequests} requests)`;
    return ` (${numberRequests} request)`;
  }

  useEffect(() => {
    setRequestsByCategories(organizeRequestsForDashboard(requests));
  }, [requests]);

  return (
    <>
      { requests.length ?
        <RequestTileContainer>
          {
            DashboardCategories.map((category, index) => (
              Object.hasOwn(requestsByCategories, category) ?
                <CategoryContainer
                  key={`${category}_${index}`}
                  title={`${category} ${getRequestCountsLabel(requestsByCategories[category].length)}`}
                  mutedColor={!canPartnerUpdateCategory(category)}
                  borderWidth={canPartnerUpdateCategory(category) ? 3 : 1}
                >
                  <RequestStageTiles
                    requests={requestsByCategories[category]}
                    handleClick={handleClick}
                    userEmails={userEmails}
                    showActionBanner={canPartnerUpdateCategory(category)}
                  />
                </CategoryContainer>
              :
                null
            ))
          }
        </RequestTileContainer>
        :
        <ErrorMessages messages={[
          <MessageItem key='emi_no_requests'>You do not have any open requests</MessageItem>
        ]}/>
      }
    </>
  );
};

export default RequestsTiles;

const RequestTileContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: auto;
`;

